export default {
  getUserMenusBreadCrumb: state => state.userMenus,
};



// WEBPACK FOOTER //
// ./src/vuex/common/breadCrumb/breadCrumbGetters.js